import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { useCreateNoteMutation, useUpdateNoteMutation } from "store/services/V2/notes";
import { userFullName, successMessageToast } from "helpers/common";
import { useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { User } from "react-feather";
import LoadingButton from "components/shared/LoadingButton";
import { useLazyTherapistLookupQuery } from "store/services/utility";
import { debounce } from "lodash";
import { RequiredFieldAstrick } from "components/Common/Common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import addAttendanceSchema from "./addSession.schema";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { ATTENDANCE_OPTIONS, STAFF_TASK_TYPE_OPTIONS } from "config/constants";
import { useAddAttendanceMutation } from "store/services/attendance";


const AttendanceTrackerModal = ({
  title,
  onCancel,
  confirmBtnText = "Save",
  show,
  setShow,
  caseLoadId,
  refetch,
  noteTableId,
  closeCallback
}) => {

  const handleClose = () => {
    setShow(false);
    typeof closeCallback === "function" && closeCallback();
  };

  const handlePopup = () => setShow(!show);

  const [addAttendance, { isLoading }] = useAddAttendanceMutation();

  const handleSubmit = async (values) => {

    try {

      // setShow(false);
      const result = await addAttendance({ therapistId: caseLoadId, data: values });
      if (!result.error) {
        const handlePopup = () => setShow(!show);
        successMessageToast(result?.data?.message);
        handlePopup()
        refetch();
      }

    } catch (err) { console.log("error adding attendance"); };
  };

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="sm"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderBottom: "1px solid #315D99" }}
          >
            <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
              TRACK ATTENDANCE
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Formik Form */}
          <Formik
            initialValues={{ session_date: "", attendance: "present" }}
            validationSchema={addAttendanceSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              values
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row >
                  <Col md="6" sm="6" className="my-3  text-start  name-input-v2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Session  Date
                    </label>
                    <AppDatePicker
                      name="session_date"
                      placeholder="e.g John"
                      className={`${styles.formControl} readonly-box h-auto`}
                      maxLength={30}
                      portalId={"root"}
                      autocomplete="off"
                    />
                  </Col>
                  <Col md="12" sm="6" className="my-3">
                    <label
                      htmlFor=""
                      className="form-label themeBlue fw-bold mb-0 d-flex"
                    >
                      Attendance
                      <RequiredFieldAstrick />
                    </label>
                    <div className="radio-inputs text-start">

                      <AppRadioField
                        containerClass={"d-flex align-items-center py-1"}
                        options={ATTENDANCE_OPTIONS}
                        name="attendance"
                        labelStyles={{
                          color: "#071E3E",
                          fontSize: "12px",
                          fontWeight: "500",
                          fontFamily: "Proxima Nova regular",
                        }}
                      />
                    </div>
                    {/* <div class="main-attendance-fields">
                      <div class="inner-attendance-fields">
                        <label class="present-absent">Present
                          <input
                            type="radio"
                            checked={values.attendance == "present"}
                            name="attendance"
                            value={"present"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                        <label class="present-absent">Absent
                          <input
                            type="radio"
                            name="attendance"
                            value={"absent"}
                            checked={values.attendance == "absent"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div> */}
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4 gap-2">
                  <Button
                    variant="secondary"
                    onClick={handleClose}
                    style={{
                      backgroundColor: "#ccc",
                      // color: "#000",
                      border: "none",
                      borderRadius: "0",
                      padding: "6px 16px",
                    }}
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>

                  <LoadingButton
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#315D99",
                      border: "none",
                      borderRadius: "0",
                      padding: "6px 16px",
                    }}
                    isLoading={isLoading}
                  >
                    Done
                  </LoadingButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AttendanceTrackerModal;
